import { render, staticRenderFns } from "./TestMailDialog.vue?vue&type=template&id=4da28921"
import script from "./TestMailDialog.vue?vue&type=script&lang=js"
export * from "./TestMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports